import MobxReactForm from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';
import AuthStore from '../../../../stores/AuthStore';
import ProfileStore from '../../../../stores/ProfileStore';
import NotificationStore from '../../../../stores/NotificationStore';
import { i18nextInstance } from '../../../../../i18n';
const fields = [
    {
        name: 'email',
        type: 'email',
        label: 'modals:offerRequest.email',
        placeholder: 'modals:offerRequest.emailPlaceholder',
        value: '',
        rules: 'required|email'
    },
    {
        name: 'password',
        label: 'modals:offerRequest.password',
        placeholder: 'modals:offerRequest.passwordPlaceholder',
        type: 'password',
        value: '',
        rules: 'required'
    }
];
const hooks = {
    onSuccess: (form) => {
        const { email, password } = form.values();
        return AuthStore.signIn(email, password, i18nextInstance.t.bind(i18nextInstance)) // ADV-287
            .then(() => AuthStore.updateToken())
            .then(() => ProfileStore.getProfileData())
            .catch((reason) => {
            NotificationStore.addNotification({
                message: i18nextInstance.t('modals:offerRequest.authorizationFailed'),
                level: 'error'
            });
            throw reason;
        });
    }
};
const plugins = {
    dvr: dvr({
        package: validatorjs
    })
};
const options = {
    validateOnBlur: true
};
export default new MobxReactForm({ fields }, { hooks, plugins, options });
